import { Injectable } from '@angular/core';
import { CurrentUser } from '@models/Core/CurrentUser';
import { of } from 'rxjs';

import { BusService } from '../bus.service';
import { EventsService } from '../events.service';
import { RequestService } from '../request.service';

type User = CurrentUser;

@Injectable()
export class AdminUserRequestService {
  api = {
    root: '/users',
    changePassword: '/password',
  };

  cachedResponses = {};

  constructor(
    private client: RequestService,
    private bus: BusService,
    private events: EventsService,
  ) {
    this.subscribe();
  }

  isCached(route) {
    return route in this.cachedResponses;
  }

  getCache(route) {
    return this.cachedResponses[route];
  }

  updateCache(route, response) {
    this.cachedResponses[route] = response;
  }

  getAll() {
    if (this.isCached('getAll')) {
      // return cached response but execute request anyways  to handle changes that may not be represented in cache
      this.bus.publish(
        this.events.received.data.user.all.success,
        this.getCache('getAll'),
      );
      return of(this.getCache('getAll'));
    }
    // always trigger request independent of cache
    return this.client.get<User[]>({
      uri: this.api.root,
      handlers: {
        success: response => {
          this.updateCache('getAll', response);
          this.bus.publish(
            this.events.received.data.user.all.success,
            response,
          );
        },
        error: error => {
          this.bus.publish(
            this.events.received.data.user.all.failure,
            error.error,
          );
        },
      },
    });
  }

  delete(user: User) {
    this.client.delete<any>({
      uri: this.api.root + `/${user._id}`,
      handlers: {
        success: response =>
          this.bus.publish(
            this.events.received.action.user.delete.success,
            response,
          ),
        error: error =>
          this.bus.publish(
            this.events.received.action.user.delete.failure,
            error.error,
          ),
      },
    });
  }

  private subscribe() {
    this.bus.subscribe(
      this.events.requested.data.user.all,
      this.getAll.bind(this),
    );
    this.bus.subscribe(
      this.events.requested.action.user.delete,
      this.delete.bind(this),
    );
  }
}
